module.exports = __webpack_public_path__ + "img/portrait2thumb.7a2d2bad.gif";